import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

// Replace this with your own config details
var config = {
    apiKey: "AIzaSyBQXSimETNrCQHTv1Wq_J6bIiPyxHsraQ8",
    authDomain: "keepitlocalrva.firebaseapp.com",
    databaseURL: "https://keepitlocalrva.firebaseio.com",
    projectId: "keepitlocalrva",
    storageBucket: "keepitlocalrva.appspot.com",
    messagingSenderId: "277373065247",
    appId: "1:277373065247:web:9f023610c085ac01891d2a",
    measurementId: "G-K1J3YG09YF"};
firebase.initializeApp(config);
firebase.firestore();

export default firebase 
